/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Divider } from '@material-ui/core';

/**
 * region for styles*/
import { detailKeywordStyle } from './style/detailKeywordStyle';

/**
 * region for components*/
import TabsKeyword from '../../components/keyword/TabsKeyword';
import RelationsKeyword from '../../components/keyword/RelationsKeyword';

class DetailKeyword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: ''
        };
    }
    render() {
        const { keywordSelect } = this.props;
        return (
            <div>
                <Typography variant="subtitle1" component="h2">
                    {keywordSelect.KEYWORD}
                </Typography>
                <Divider />
                <RelationsKeyword
                    keyword={keywordSelect} />
                <TabsKeyword
                    keyword={keywordSelect} />
            </div>
        );
    }
}
DetailKeyword.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(detailKeywordStyle)(DetailKeyword);